import CollectPaymentView from "./CollectPaymentView";

const RequestMoney = () => {
  return <CollectPaymentView />;
};

export default RequestMoney;
